// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__33sxN","content":"RecentSearches_content__3PaMG"};